import type { SpaceTypeEnum } from '@bambi/api-client/schemas';

export const spaceTypes: SpaceTypeEnum[] = [
  'wheelchair',
  'wheelchair xl',
  'stretcher',
  'stretcher xl',
  'ambulatory',
  'broda chair',
  'geri chair',
  'delivery',
];
